import { Button, Modal } from "react-bootstrap";

import './ratioChangeModal.scss';

const RatioChangeModal = ({
    openRatioChangeModal,
     setOpenRatioChangeModal,
     ratioChangeConfirmation
    }) => {

    return (
        <>
            <Modal
                show={openRatioChangeModal}
                size="lg"
                centered
                className="delete-image-tab-modal"
            >   
                <Modal.Body className="delete-image-tab-modal-body">
                    {/* <h2 className="delete-image-tab-header">Delete</h2> */}
                    <p className="delete-image-tab-content">Please ensure slide is designed and saved before switching to different ratio. <span className="delete-image-tab-confirmation-text">Are you sure?</span></p>
                </Modal.Body>
                <Modal.Footer className="delete-image-tab-footer">
                    <Button onClick={() => ratioChangeConfirmation('NO', '')} className="delete-image-tab-confirmation-no">
                     CANCEL
                    </Button>
                    <Button onClick={() => ratioChangeConfirmation('YES', '')} className="delete-image-tab-confirmation-yes">
                     PROCEED
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default RatioChangeModal;